import { Auth0ClientInstance } from "./Auth0ClientInstance";
import { LoginAction } from "../../actions/LoginAction";
import { RegisterAction } from "../../actions/RegisterAction";
import { LogoutAction } from "../../actions/LogoutAction";
import { AuthUIController } from "./AuthUIController";
import { logService } from "@Engage.Core";
export class Auth0Plugin {
    constructor(options) {
        this.options = options;
        this.name = "Auth0";
    }
    async init() {
        await Auth0ClientInstance.init(this.options);
        new LoginAction().register();
        new RegisterAction().register();
        new LogoutAction().register();
        await AuthUIController.sync();
        logService.log("[Auth0] initialized");
    }
}
